import React, { useMemo } from "react";
import { Box } from "@mui/system";
import MaterialReactTable from "material-react-table";
import { EmissionsAllocationOverviewRequestBody } from "api";
import { useEmissionAllocationOverviewById } from "hooks";
import { Loading } from "components";
import { getEmissionsAllocationColumns } from "./components";

export const EmissionsAllocationTable = ({ query }: { query: EmissionsAllocationOverviewRequestBody }) => {
    const { data, isFetching } = useEmissionAllocationOverviewById(query);
    const columns = useMemo(
        () => getEmissionsAllocationColumns(),
        []
    );
    if (isFetching) return <Loading />

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2, width: "100%" }}>
            <MaterialReactTable
                enableTopToolbar
                muiTableContainerProps={{
                    sx: {
                        "& thead tr:first-of-type th:first-of-type": {
                            paddingLeft: "20px",
                        },
                        "& tbody tr td:first-of-type": {
                            paddingLeft: "20px",
                        },
                        "& tbody tr:first-of-type td > p": {
                            display: "flex",
                            width: "100%",
                            justifyContent: "center",
                        },
                        height: "calc(100vh - 493px)",
                        minHeight: "200px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "10px",
                        width: "100%",
                    },
                }}
                muiTablePaperProps={{
                    sx: {
                        borderRadius: "10px",
                        boxShadow: "none",
                    },
                }}
                muiTopToolbarProps={{
                    sx: {
                        height: '1px',
                        minHeight: '1px',
                        backgroundColor: 'transparent',
                        '& .MuiIconButton-root': {
                            display: 'none',
                        },
                    },
                }}
                muiBottomToolbarProps={{
                    sx: {
                        display: "none",
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        lineHeight: "30px",
                        "& .MuiBadge-root": {
                            display: "none",
                        },
                    },
                }}
                muiTableHeadRowProps={{
                    sx: {
                        "& > th:first-of-type": {
                            paddingLeft: "20px",
                        },
                        "& > th": {
                            paddingTop: 1,
                            paddingBottom: 1,
                        },
                        height: "auto",
                        backgroundColor: "#F8FAFC",
                    },
                }}
                muiTableBodyRowProps={{
                    sx: {
                        backgroundColor: "white",
                    },
                }}
                columns={columns}
                data={data || []}
                enableColumnResizing
                enableDensityToggle={false}
                initialState={{ density: "compact" }}
                enablePagination={false}
                enableRowVirtualization
                enableGrouping
            />
        </Box>
    )
}